// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"9bdace17","94":"55c63ad2","120":"48e130c9","126":"80ab2078","171":"cdec6b9c","407":"c05753f4","432":"6b4978a4","532":"5d0715b6","674":"49ac047b","684":"c00fa4c3","711":"30e08a21","744":"a14dc332","994":"260f54c8"}[chunkId] + ".chunk.js";
};